module.exports = __webpack_public_path__ + "officialStatic/img/gw-detailList2.34d5e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/gw-detailList2.png
// module id = xbUo
// module chunks = 0